import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { TextField } from "@mui/material";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";

export default function AboutSection({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [offices, setOffices] = useState([]);
  const [slides, setSlides] = useState([]);
  const [images, setImages] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [whereWasClicked, setWhereWasClicked] = useState({});
  const hiddenFileInput = useRef();
  const hiddenFileInput2 = useRef();
  const hiddenFileInput3 = useRef();
  const hiddenFileInput4 = useRef();

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      introduction: "",
      btnT: "",
      btnL: "",
      language: item.attributes.language,
    }));
    setData(docs);

    async function getData() {
      await fetch(`${API}/about-us`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.homeAboutData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                introduction: apiItem.introduction || localItem.introduction,
                btnT: apiItem.btnT || localItem.btnT,
                btnL: apiItem.btnL || localItem.btnL,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    let updatedData = [...data];

    fetch(`${API}/about-us`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { homeAboutData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
        setData(updatedData);
      } else {
        setFail(true);
      }
    });
  };

  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>About Us Section</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                    }}>
                    <div>
                      <p style={{ fontSize: 15 }}>Introduction for About Us in the Home Page</p>

                      <div style={{ margin: "20px 0" }}>
                        <TextEditor
                          value={data[index]?.introduction || ""}
                          onChange={(v) => {
                            setData([
                              ...data.map((item, idx) => {
                                if (idx === index) {
                                  return {
                                    ...item,
                                    introduction: v,
                                  };
                                } else {
                                  return item;
                                }
                              }),
                            ]);
                          }}
                        />
                      </div>
                    </div>

                    <TextField
                      label="Action Button Text"
                      sx={{ width: 250 }}
                      value={data[index]?.btnT}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                btnT: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />

                    <TextField
                      label="Action Button Link"
                      sx={{ width: 250 }}
                      value={data[index]?.btnL}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                btnL: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  {user.perms[7].edit && (
                    <div className="submitBTN" onClick={() => submitData(item, index)}>
                      Save Changes
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
